import {
  defaultSalesDetailDto,
  SalesDetailDto,
} from "src/dtos/sales/salesDto";

export interface PDA1030_R01Dto extends SalesDetailDto {
}

export interface PDA1030_R01Filter {
  compCd: string;
  startDate: string;
  endDate: string;
}

export const defaultPDA1030_R01Dto: PDA1030_R01Dto = {
  ...defaultSalesDetailDto,
};
